import styled from '@emotion/styled';
import { Box } from '@mui/material';

import { palette } from '../../theme';
export const LocationWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '12px',
  border: `1px solid ${palette.line}`,
  borderRadius: '10px'
});

export const GroupBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '32px',
  padding: '4px 6px',
  gap: '4px',
  border: `1px solid ${palette.field.border}`,
  borderRadius: '6px'
});
